module.exports = __webpack_public_path__ + "static/media/BidCard.e14d58b5.png";